import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { formStatusDispatchHelper, formReset } from 'actions/FormStatusActions';

import WhiteLabelForm from 'components/forms/whiteLabel/WhiteLabelForm';

class WhiteLabelNewForm extends React.Component {
  render() {
    const { onSubmit, onSubmitParent, formStatus } = this.props;

    return <WhiteLabelForm type="new" onSubmit={onSubmit} onSubmitParent={onSubmitParent} formStatus={formStatus} />;
  }
}

const mapStateToProps = state => {
  return {
    formStatus: state.formStatus.whiteLabelNew,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onSubmit: args => {
      formStatusDispatchHelper('whiteLabelNew', '/api/whitelabels.json', args, 'post', dispatch);
    },
    onFormSuccessfull: () => {
      dispatch(formReset('whiteLabelNew'));
    },
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(WhiteLabelNewForm)
);
